import {
  DATA_CATEGORICAL_100,
  DATA_CATEGORICAL_200,
  DATA_CATEGORICAL_300,
  DATA_CATEGORICAL_400,
  DATA_CATEGORICAL_500,
  DATA_CATEGORICAL_600,
  DATA_CATEGORICAL_700,
  DATA_CATEGORICAL_800,
  DATA_CATEGORICAL_900,
} from '@sama/design-tokens';

export const DEFAULT_ZOOM_PANEL_SCALE = 10;
export const defaultAnnotationColor = '#0063ff';
export const TRAINING_SHAPE_COLOR = '#00FF29';
export const sourceIdColors: string[] = [
  DATA_CATEGORICAL_100,
  DATA_CATEGORICAL_200,
  DATA_CATEGORICAL_300,
  DATA_CATEGORICAL_400,
  DATA_CATEGORICAL_500,
  DATA_CATEGORICAL_600,
  DATA_CATEGORICAL_700,
  DATA_CATEGORICAL_800,
  DATA_CATEGORICAL_900,
];
